import ThreeLineTitle from "../components/TheThreeLineTitle.vue";
import { Validation } from "../utils/validation";
import { updatePointExcludedProductCode, getBrandsMaster, getPointTypesMaster, } from "../api";
import { Authorize } from "../utils/authorize";
export default {
    components: { ThreeLineTitle },
    data() {
        return {
            pointInfo: [],
            brandInfo: [],
            form: {
                non_target_point_grant_id: "",
                point_type_id: "",
                brand_id: "",
                item_code: "",
                item_name: "",
            },
        };
    },
    async created() {
        await this.callApi();
        const query = this.$route.query;
        if (query.non_target_point_grant_id)
            this.form.non_target_point_grant_id =
                query.non_target_point_grant_id;
        if (query.point_type_id)
            this.form.point_type_id = query.point_type_id;
        if (query.brand_id)
            this.form.brand_id = query.brand_id;
        if (query.item_code)
            this.form.item_code = query.item_code;
        if (query.item_name)
            this.form.item_name = query.item_name;
    },
    watch: {
        "form.point_type_id": async function (newPointType) {
            if (!newPointType) {
                this.brandInfo = [];
                this.form.brand = "";
                return;
            }
            try {
                const response = await getBrandsMaster(newPointType);
                if (response.result?.code === 9) {
                    this.$store.commit("setMessages", response.result.messages);
                    this.$store.commit("setCancelBtnHide", true);
                    this.$store.commit("setIsModalOpen", true);
                }
                else {
                    this.brandInfo = response.data.results || [];
                    if (!this.storeInfo.find((b) => b.brandId === this.form.brand)) {
                        this.form.brand = "";
                    }
                }
            }
            catch (err) {
                //
            }
        },
    },
    methods: {
        validate(form) {
            const errors = [];
            // 必須チェック
            errors.push(...Validation.requiredInput({
                key: "ポイント種類",
                value: form.point_type_id,
            }));
            errors.push(...Validation.requiredInput({ key: "ブランド", value: form.brand_id }));
            errors.push(...Validation.requiredInput({
                key: "商品コード",
                value: form.item_code,
            }));
            errors.push(...Validation.requiredInput({ key: "商品名", value: form.item_name }));
            // 桁数チェック
            errors.push(...Validation.digitsMax({
                key: "商品コード",
                value: form.item_code,
            }, 40));
            errors.push(...Validation.digitsMax({
                key: "商品名",
                value: form.item_name,
            }, 50));
            // 属性チェック
            errors.push(...Validation.isNotContainSymbols({
                key: "商品コード",
                value: form.item_code,
            }));
            if (errors.length > 0) {
                return errors;
            }
            return "";
        },
        async handleSetting() {
            try {
                // API呼び出し用のオブジェクト作成
                const updateData = {
                    non_target_point_grant_id: this.form.non_target_point_grant_id,
                    point_type_id: this.form.point_type_id,
                    brand_id: this.form.brand_id,
                    item_code: this.form.item_code,
                    item_name: this.form.item_name,
                };
                const errors = this.validate(updateData);
                if (errors.length > 0) {
                    this.$store.commit("setMessages", errors);
                    this.$store.commit("setCancelBtnHide", true);
                    this.$store.commit("setIsModalOpen", true);
                    return;
                }
                // API登録処理呼び出し
                const response = await updatePointExcludedProductCode(updateData);
                if (response.result?.code === 9) {
                    this.$store.commit("setMessages", response.result.messages);
                    this.$store.commit("setCancelBtnHide", true);
                    this.$store.commit("setIsModalOpen", true);
                }
                else {
                    // 更新成功後に検索画面へ遷移
                    this.$router.push("/searchPointExcludedProductCode");
                }
            }
            catch (error) {
                //
            }
        },
        onCancel() {
            this.$router.back();
        },
        onSubmit() {
            this.handleSetting();
        },
        async callApi() {
            try {
                // ブランドマスタ取得
                const gbResponse = await getBrandsMaster();
                if (gbResponse.result?.code === 9) {
                    this.$store.commit("setMessages", gbResponse.result.messages);
                    this.$store.commit("setCancelBtnHide", true);
                    this.$store.commit("setIsModalOpen", true);
                }
                else {
                    this.brandInfo = gbResponse.data.results;
                }
                // ポイント種別マスタ取得
                const gPMResponse = await getPointTypesMaster();
                if (gPMResponse.result?.code === 9) {
                    this.$store.commit("setMessages", gPMResponse.result.messages);
                    this.$store.commit("setCancelBtnHide", true);
                    this.$store.commit("setIsModalOpen", true);
                }
                else {
                    this.pointInfo = gPMResponse.data.results;
                }
            }
            catch (error) {
                //
            }
        },
    },
    async mounted() {
        await Authorize.isExpired(this);
    },
};
